import { lazy, Suspense } from 'react';

import { useQuery } from '@tanstack/react-query';

import { WithStateQuery } from '@/components/ui/with-state';
import { userQueries } from '@/queries/user/user.queries';
import { Roles } from '@/types/roles';

const HomeAccountManager = lazy(
	() => import('@/components/features/account-manager/home-account-manager')
);

const HomeProcurement = lazy(
	() => import('@/components/features/procurement/home-procurement')
);

const HomeVAO = lazy(() => import('@/components/features/vao/home-vao'));

export default function Home() {
	const user = useQuery(userQueries.user());

	return (
		<WithStateQuery state={user}>
			{({ data: { roleId } }) => {
				if (!roleId) return null;

				let Component = null;
				if (roleId === Roles.AccountManager) {
					Component = HomeAccountManager;
				}

				if (roleId === Roles.Procurement || roleId === Roles.Compliance) {
					Component = HomeProcurement;
				}

				if (roleId === Roles.VendorAuthorizedOfficer) {
					Component = HomeVAO;
				}

				if (Component) {
					return (
						<Suspense>
							<Component roleId={roleId} />
						</Suspense>
					);
				}

				return null;
			}}
		</WithStateQuery>
	);
}
